<template>
  <div class="order-detail">
    <div class="container">
      <div class="breadcrumb">
        <router-link to="/workbench/patternMakerOrder" class="link"
          >打版订单</router-link
        >
        <span class="link">></span>
        <span class="link"> 订单详情 </span>
      </div>
      <div class="flex justify-between">
        <div class="left-box">
          <div class="flex align-center justify-between">
            <div class="title">{{ detail.task_title }}</div>
            <div class="status" :class="detail.status_text">
              {{ detail.status_name }}
            </div>
          </div>
          <div class="margin-top-10 text-666">
            订单编号：{{ detail.make_no }}
          </div>
          <div class="margin-top-20 info-box">
            <div class="w33">
              <div class="text-666">派单时间</div>
              <div>{{ detail.assign_time }}</div>
            </div>
            <div class="w33">
              <div class="text-666">服装品类</div>
              <div>{{ detail.design_data.category.name }}</div>
            </div>
            <div class="w33">
              <div class="text-666">交付周期</div>
              <div>
                <span class="">1天内</span>
                <span class="text-666">（接受派单后开始计算）</span>
              </div>
            </div>
          </div>
          <div class="back-tips" v-if="detail.status == 4">
            <div class="flex align-center">
              <img
                src="../../assets/images/patternMaker/ico_info.png"
                style="width: 14px; height: 14px"
              />
              <span class="" style="color: #ff5000">修改意见（请仔细阅读相关修改细节，尽快完成修改并重新上传相关文件）：</span>
            </div>
            <div
              class="margin-top-10 text-666"
              v-html="detail.platform_reason"
            ></div>
          </div>
          <div class="tabs">
            <div
              class="tab-item flex align-center"
              :class="[currTab == 1 ? 'active' : '']"
              @click="onTabClick(1)"
            >
              <img src="../../assets/images/patternMaker/ico_detailed.png" />
              <span class="margin-left-10">需求详情</span>
            </div>
            <div
              class="tab-item flex align-center"
              :class="[currTab == 2 ? 'active' : '']"
              @click="onTabClick(2)"
            >
              <img src="../../assets/images/patternMaker/ico_link.png" />
              <span class="margin-left-10">资料附件</span>
            </div>
          </div>
          <template v-if="currTab == 1">
            <div class="title-line">款式说明：</div>
            <div class="desc" v-html="detail.require_style"></div>
            <div class="title-line">面料要求：</div>
            <div class="desc" v-html="detail.require_fabric"></div>
            <div class="title-line">工艺要求：</div>
            <div class="desc" v-html="detail.require_tech"></div>
            <div class="title-line">尺寸要求：</div>
            <div class="desc" v-html="detail.require_size"></div>
            <div class="title-line">交付要求：</div>
            <div class="desc" v-html="detail.require_submit"></div>
          </template>
          <template v-if="currTab == 2">
            <div class="title-line">款式设计图：</div>
            <div class="flex flex-wrap design-img-list">
              <div
                class="item"
                v-for="(item, index) in detail.design_data.category.image_list"
                :key="index"
              >
                <img
                  v-if="util.test_image(item)"
                  :src="item"
                  alt=""
                  class="image"
                  v-viewer
                />
                <img
                  v-if="typeof item === 'object' && util.test_image(item.raw)"
                  :src="item.raw"
                  alt=""
                  class="image"
                  v-viewer
                />

              </div>
            </div>
            <div class="title-line">文档附件：</div>
            <div class="margin-top-20 file-list">
              <a
                class="file-item flex align-center justify-between"
                target="_blank"
                :href="v.path"
                v-for="(v, index) in detail.design_data.category.other_file"
                :key="index"
              >
                <div class="flex align-center">
                  <img :src="util.get_image_icon(v.path)" class="icon-doc" />
                  <span class="margin-left-10">{{ v.name }}</span>
                </div>
                <div class="flex align-center">
                  <img
                    src="../../assets/images/patternMaker/download.png"
                    class="download-img"
                  />
                  <span class="download">下载</span>
                </div>
              </a>
            </div>
          </template>
        </div>
        <div class="right-box">
          <div class="bg-white" style="padding: 25px">
            <div class="text-666">打版预算：</div>
            <div class="text-666 margin-top-10 price-box">
              <span class="price">¥{{ detail.settle_money }}</span>
              <span class="text-666">/款</span>
            </div>
            <template v-if="detail.status == 0">
              <!-- <div class="text-666 margin-top-20">派单剩余处理时间</div>
              <div class="time margin-top-10">2小时28分</div>
              <div class="text-666 margin-top-10">超时将自动拒绝</div> -->
              <div
                class="btn btn-upload flex align-center justify-center margin-top-30 pointer"
                @click.stop="acceptOrder()"
              >
                我要接单
              </div>
              <div
                class="btn btn-reject flex align-center justify-center margin-top-10 pointer"
                @click.stop="refuseOrder()"
              >
                拒绝接单
              </div>
              <div class="margin-top-20 text-center">
                <span class="text-666">接单即表示您已阅读并同意</span>
                <span
                  class=""
                  style="color: #0d99ff"
                  @click="onServiceRuleClick()"
                  >《版师服务协议》</span
                >
              </div>
            </template>

            <template v-if="detail.status == 2">
              <div class="text-666 margin-top-20">剩余交付时间</div>
              <div class="time margin-top-10">{{countdownText}}</div>
              <div class="text-666 margin-top-10">
                请在以上时间内完成打版并提交文件，否则将影响您在平台的评分！
              </div>
              <div
                v-if="detail.pattern.length > 0"
                class="upload-files margin-top-20"
              >
                <div
                  class="text-666"
                  style="padding-top: 20px; border-top: 1px solid #e3e3e3"
                >
                  已上传文件：
                </div>
                <div class="margin-top-20">
                  <PatternFile
                    :pattern="detail.pattern"
                    :status="detail.status"
                    @uploadPattern="uploadPattern"
                  ></PatternFile>
                </div>
                <div class="flex justify-center">
                  <Upload
                    action=""
                    :data="{ dir: 'template' }"
                    :before-upload="(file) => onBeforeUpload(file)"
                    :show-upload-list="false"
                  >
                    <div
                      class="margin-top-20 text-center text-16 pointer"
                      style="color: #0d99ff"
                    >
                      继续上传文件
                    </div>
                  </Upload>
                </div>

                <div
                  class="btn btn-upload flex align-center justify-center margin-top-20 pointer"
                  @click="submitPattern"
                >
                  确认提交版型文件
                </div>
              </div>

              <div class="margin-top-20" v-if="detail.pattern.length == 0">
                <Upload
                  action=""
                  :data="{ dir: 'template' }"
                  :before-upload="(file) => onBeforeUpload(file)"
                  :show-upload-list="false"
                >
                  <div
                    class="btn btn-upload flex align-center justify-center pointer"
                  >
                    <img
                      src="../../assets/images/patternMaker/ico_upload.png"
                      class="upload-img"
                    />
                    <span class="margin-left-10">上传版型文件</span>
                  </div>
                </Upload>

                <div class="text-666 text-12 margin-top-20">
                  支持格式：PDF、AI、CDR、DXF、Word等，单个文件≤20MB
                </div>
              </div>
            </template>
            <template v-if="detail.status == 3">
              <div
                class="margin-top-20 text-center text-18 text-bold"
                style="color: #0d99ff"
              >
                成功提交，版型文件审核中...
              </div>
              <!-- <div class="text-center margin-top-10 text-999 text-12">
                提交时间：2026-02-01 17:30:00
              </div> -->
              <div class="text-666 margin-top-16">
                辛苦啦！你的打版文件已经成功提交，平台审核专员将依据行业制版标准与平台规则完成核验，请耐心等待~
              </div>
              <div class="text-666 margin-top-10">
                审核结果或修改要求会直接展示在本页面，消息中心也会同步提醒，到时版师需按反馈完成整改后重新提交审核即可。
              </div>

              <div
                v-if="detail.pattern.length > 0"
                class="upload-files margin-top-20"
              >
                <div
                  class="text-666"
                  style="padding-top: 20px; border-top: 1px solid #e3e3e3"
                >
                  已上传文件：
                </div>
                <div class="margin-top-20">
                  <PatternFile
                    :pattern="detail.pattern"
                    :status="detail.status"
                    @uploadPattern="uploadPattern"
                  ></PatternFile>
                </div>
              </div>
            </template>
            <template v-if="detail.status == 9">
              <div
                class="margin-top-20 text-center text-18 text-bold"
                style="color: #ff5967"
              >
                审核通过，订单待结算中...
              </div>
              <!-- <div class="text-center margin-top-10 text-999 text-12">
                通过时间：2026-02-01 17:30:00
              </div> -->
              <div class="text-666 margin-top-16">
                恭喜你！你提交的版型文件顺利通过审核，订单当前处于待结算状态，平台将在7个工作日内处理结算，请耐心等待~
              </div>
              <div class="text-666 margin-top-10">
                结算完成后酬劳会自动进到你的账户余额中，你可以在余额明细中随时查看每一笔订单的结算明细。
              </div>

              <div
                v-if="detail.pattern.length > 0"
                class="upload-files margin-top-20"
              >
                <div
                  class="text-666"
                  style="padding-top: 20px; border-top: 1px solid #e3e3e3"
                >
                  已上传文件：
                </div>
                <div class="margin-top-20">
                  <PatternFile
                    :pattern="detail.pattern"
                    :status="detail.status"
                    @uploadPattern="uploadPattern"
                  ></PatternFile>
                </div>
              </div>
            </template>
            <template v-if="detail.status == 10">
              <div
                class="margin-top-20 text-center text-18 text-bold"
                style="color: #02c160"
              >
                订单已结算
              </div>
              <!-- <div class="text-center margin-top-10 text-999 text-12">
                结算时间：2026-02-04 16:59:20
              </div> -->
              <div class="text-666 margin-top-16">
                该订单已完成结算，相关酬劳已按约定发放至你的账户，可前往账户余额明细中查看入账记录，感谢你专业的制版服务，期待与你再次携手合作！
              </div>
              <div
                class="margin-top-20"
                style="padding-top: 20px; border-top: 1px solid #e3e3e3"
              >
                <div class="flex justify-between">
                  <span class="text-666">结算金额：</span>
                  <div class="">
                    <div
                      class="text-16 text-bold text-right"
                      style="color: #ff5967"
                    >
                      ¥800.00
                    </div>
                    <a
                      class="text-12 pointer"
                      style="color: #0d99ff; margin-top: 7px"
                      href="/workbench/userBalance" target="_blank"
                    >
                      查看余额明细
                    </a>
                  </div>
                </div>
              </div>

              <div
                v-if="detail.pattern.length > 0"
                class="upload-files margin-top-20"
              >
                <div
                  class="text-666"
                  style="padding-top: 20px; border-top: 1px solid #e3e3e3"
                >
                  已上传文件：
                </div>
                <div class="margin-top-20">
                  <PatternFile
                    :pattern="detail.pattern"
                    :status="detail.status"
                    @uploadPattern="uploadPattern"
                  ></PatternFile>
                </div>
              </div>
            </template>
            <template v-if="detail.status == 4">
              <div
                class="margin-top-20 text-center text-18 text-bold"
                style="color: #ff5000"
              >
                订单驳回修改
              </div>
              <!-- <div class="text-center margin-top-10 text-999 text-12">
                驳回时间：2026-02-01 17:30:00
              </div> -->
              <div class="text-666 margin-top-16">
                本次审核未通过，具体修改要求请看右侧的【修改意见】，请认真阅读修改要求，确认所有问题修正后再上传，避免局部漏改误改导致再次不通过，修改完毕后替换原文件再次提交，平台将按顺序重新审核~
                感谢您的配合！
              </div>

              <div
                v-if="detail.pattern.length > 0"
                class="upload-files margin-top-20"
              >
                <div
                  class="text-666"
                  style="padding-top: 20px; border-top: 1px solid #e3e3e3"
                >
                  已上传文件：
                </div>
                <div class="margin-top-20">
                  <PatternFile
                    :pattern="detail.pattern"
                    :status="detail.status"
                    @uploadPattern="uploadPattern"
                  ></PatternFile>
                </div>
              </div>
              <div class="flex justify-center">
                <Upload
                  action=""
                  :data="{ dir: 'template' }"
                  :before-upload="(file) => onBeforeUpload(file)"
                  :show-upload-list="false"
                >
                  <div
                    class="margin-top-20 text-center text-16 pointer"
                    style="color: #0d99ff"
                  >
                    上传版型文件
                  </div>
                </Upload>
              </div>

              <div
                class="btn btn-upload flex align-center justify-center margin-top-20 pointer"
                @click="reuploadPattern"
              >
                确认重新提交版型文件
              </div>
            </template>
          </div>
          <div
            class="bg-white margin-top-20 flex align-center justify-center pointer"
            style="height: 55px; padding: 25px" @click="showChat"
          >
            <img
              src="../../assets/images/patternMaker/ico_chat.png"
              style="height: 24px; width: 24px"
            />
            <span class="text-666 margin-left-10 ">在线沟通</span>
          </div>
        </div>
      </div>
    </div>

    <AcceptOrder ref="AcceptOrder" @confirm="getDetail"></AcceptOrder>
    <RefuseOrder ref="RefuseOrder" @confirm="getDetail"></RefuseOrder>
    <Chat ref="chat"></Chat>
    <popup
      :show.sync="is_popup_show"
      width="680px"
      height="520px"
      @on-close="is_popup_show = false"
    >
      <div class="agree-content">
        <div v-html="setting.patternMakerAgreement"></div>
      </div>
    </popup>
  </div>
</template>

<script>
import {
  GetOrderMakeDetail,
  OrderMakeReupload,
  OrderMakeSubmit, OrderTimeout
} from "@/api/index.js";
import util from "@/utils/util";
import { mapState } from "vuex";
import AcceptOrder from "./components/Accept";
import PatternFile from "./components/PatternFile";
import RefuseOrder from "./components/Refuse";

import Popup from "@/components/Popup";
import { uploadFileToOSS } from "@/utils/oss";
import dayjs from "dayjs";
export default {
  name: "OrderCenter",
  components: {
    AcceptOrder,
    RefuseOrder,
    Popup,
    PatternFile,
  },
  data() {
    return {
      detail: {
        status: 0,
        pattern: [],
        design_data: {
          category: {},
        },
      },
      uuid: "",
      currTab: 1,
      util,
      status: "版型修改",
      is_popup_show: false,
      countdownTimer: null,
      deadline: null,
      countdownText: "00 时 00 分",
    };
  },
  watch: {},
  computed: {
    ...mapState({
      setting: (state) => state.setting,
    }),
  },
  async mounted() {
    const { uuid } = this.$route.query;
    this.uuid = uuid;
    await this.getDetail();
  },
  beforeDestroy() {
    // 组件销毁时清除定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  },
  methods: {
    onServiceRuleClick() {
      this.is_popup_show = true;
    },
    acceptOrder() {
      this.$refs.AcceptOrder.showModal(this.detail);
    },
    refuseOrder() {
      this.$refs.RefuseOrder.showModal(this.detail);
    },
    showChat() {
      this.$refs.chat.showChat();
    },
    async getDetail() {
      return GetOrderMakeDetail({
        uuid: this.uuid,
      })
        .then((response) => {
          this.detail = response.data;
          // 状态为 2 时启动倒计时（待提交状态）
          if (this.detail.status == 2 && this.detail.timeout_time && dayjs().isBefore(this.timeout_time)) {
            this.initCountdown(this.detail.timeout_time);
          }
        })
        .catch((err) => {
          this.$layer.msg(err.msg);
        });
    },
    //初始化倒计时
    initCountdown(deadlineTime) {
      this.deadline = dayjs(deadlineTime);
      this.updateCountdown();
      
      // 清除旧定时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      
      // 每秒更新一次
      this.countdownTimer = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    },
    // 更新倒计时
    async updateCountdown() {
      const now = dayjs();
      const diff = this.deadline.diff(now, 'second');
      
      if (diff <= 0) {
        // 倒计时结束
        this.countdownText = "00 时 00 分";
        clearInterval(this.countdownTimer);
        this.$layer.msg('交付时间已截止');
        await OrderTimeout({uuid:this.detail.uuid});
        await this.getDetail();
        return;
      }
      
      // 使用 dayjs duration 计算时分
      const durationObj = dayjs.duration(diff, 'second');
      const hours = durationObj.hours() + durationObj.days() * 24;
      const minutes = durationObj.minutes();
      
      // 格式化为 xx 时 xx 分
      this.countdownText = `${String(hours).padStart(2, '0')}时 ${String(minutes).padStart(2, '0')}分`;
    },
    onTabClick(index) {
      this.currTab = index;
    },

    uploadPattern(files) {
      this.detail.pattern = files;
    },
    onBeforeUpload(file) {
      uploadFileToOSS(file, "template").then((url) => {
        if(!util.is_pattern_file(file.name)){
          this.$layer.msg('请上传符合规格的版型文件');
          return;
        }
        this.detail.pattern.push({
          name: file.name,
          path: url,
        });
      });
      return false;
    },
    submitPattern() {
      OrderMakeSubmit({
        uuid: this.detail.uuid,
        pattern: this.detail.pattern,
      })
        .then(() => {
          this.$layer.msg("上传成功");
          this.getDetail();
        })
        .catch((e) => {
          this.$layer.msg(e.msg);
        });
    },
    reuploadPattern() {
      OrderMakeReupload({
        uuid: this.detail.uuid,
        pattern: this.detail.pattern,
      })
        .then(() => {
          this.$layer.msg("上传成功");
          this.getDetail();
        })
        .catch((e) => {
          this.$layer.msg(e.msg);
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.order-detail {
  background-color: #f8f9fb;

  .container {
    height: 100%;
    width: 1270px;
    margin: auto;
    padding-bottom: 70px;

    .breadcrumb {
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;
      text-align: left;

      .link:last-child {
        line-height: 29px;
        color: #333333;
      }

      .link {
        margin-right: 10px;
        color: #999999;
      }
    }

    .left-box {
      width: 852px;
      background: #ffffff;
      padding: 24px;

      .title {
        font-weight: bold;
        font-size: 24px;
        color: #333333;
      }

      .info-box {
        height: 92px;
        background: #f8f9fb;
        padding: 20px 0;
        display: flex;
        color: #000000;

        .w33 {
          height: 100%;
          width: 33%;
          padding-left: 14px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
      }

      .status {
        width: 74px;
        height: 29px;
        vertical-align: middle;
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        white-space: nowrap;

        &.wait_reply {
          color: #ff5000;
        }
        &.wait_submit {
          color: #0d99ff;
        }
        &.wait_factory_confirm {
          color: #02c160;
        }
        &.wait_revise {
          color: #ff5000;
        }
        &.complete {
          color: #666666;
        }
        &.settled {
          color: #666666;
        }
        &.rejected {
          color: #999999;
        }
      }
      .back-tips {
        background: #fefce8;
        padding: 14px 20px;
        margin-top: 16px;
      }
      .tabs {
        margin-top: 30px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 1px solid #d6d6d6;
        height: 50px;

        .tab-item {
          font-size: 16px;
          margin-right: 45px;
          color: #333333;
          cursor: pointer;
          margin-right: 50px;
          position: relative;
          height: 100%;

          &.active {
            font-weight: bold;
            font-size: 18px;

            &::after {
              content: "";
              position: absolute;
              left: 0;
              bottom: 0px;
              width: 100%;
              height: 0;
              border-bottom: 3px solid #ff5967;
            }
          }

          img {
            width: 20px;
            height: 20px;
          }
        }

        .tab-item.active {
          border-bottom: none !important;
        }
      }

      .title-line {
        font-weight: bold;
        font-size: 18px;
        color: #333333;
        margin-top: 24px;
        line-height: 20px;
        position: relative;

        &::before {
          content: "";
          position: absolute;
          left: -10px;
          top: 2px;
          width: 3px;
          height: 16px;
          background: #ff5967;
        }
      }

      .desc {
        margin-top: 10px;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 26px;
      }

      .design-img-list {
        gap: 20px;
        margin-top: 20px;

        .item {
          position: relative;
          width: 186px;
          cursor: pointer;

          .image {
            width: 186px;
            height: 186px;
            object-fit: cover;
            border: 1px solid #ebedf2;
          }

          .mask {
            display: none;
          }

          &:hover {
            .mask {
              display: block;
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              width: 186px;
              height: 186px;
              z-index: 10;
              background: rgba(0, 0, 0, 0.35);
              border-radius: 10px;

              .icon-mag {
                position: absolute;
                width: 32px;
                height: 32px;
                top: calc(50% - 16px);
                left: calc(50% - 16px);
                transform: translate(-50% -50%);
              }

              .icon-download {
                position: absolute;
                width: 20px;
                height: 20px;
                bottom: 10px;
                right: 10px;
              }
            }
          }

          &:nth-child(4n) {
            margin-right: 0;
          }
        }
      }
    }
    .file-list {
      .file-item {
        height: 76px;
        display: flex;
        background: #F8F9FB;
        margin: 16px 0;
        padding: 0 24px;
        .icon-doc {
          width: 42px;
          height: 42px;
        }
        .download-img {
          width: 20px;
          height: 20px;
        }
      }
    }

    .right-box {
      width: 400px;
      .price-box {
        padding-bottom: 18px;
        border-bottom: 1px solid #e3e3e3;
        .price {
          font-weight: bold;
          font-size: 28px;
          color: #ff5000;
        }
      }
      .time {
        font-weight: bold;
        font-size: 18px;
        color: #ff5967;
      }
      .btn-upload {
        width: 350px;
        height: 46px;
        background: #ff5967;
        border-radius: 6px;
        font-weight: bold;
        font-size: 16px;
        color: #ffffff;
        .upload-img {
          width: 20px;
          height: 20px;
        }
      }
      .btn-reject {
        width: 350px;
        height: 46px;
        background: #ffffff;
        border-radius: 6px 6px 6px 6px;
        border: 1px solid #b3b3b3;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
      }
    }
  }
}
</style>
